import { actionOpenAppUtils } from "./app/action-open-app/IActionOpenApp.inft";
import { actionToAppMainPageUtils } from "./app/to-app-main-page/IToAppMainPage.intf";
import { actionA11yNodeExecuteUtils } from "./a11y/node-execute/node-execute";

export function initActions(){
    actionOpenAppUtils.init()
    actionToAppMainPageUtils.init()
    actionA11yNodeExecuteUtils.init()
}

